import { Node } from "typescript"

class  ReferrerService {
   private static readonly PAPERSUBPATH = '/student/dashboard'
   private referrerUrl: string 
   private loginElements: NodeListOf<Element>

   constructor() {
    this.referrerUrl = document.referrer
    this.loginElements = document.querySelectorAll("div.login-form-component, div.login-form-component-hidden");
   
   }

   public checkRequestOrigin(): void {
    if (this.isFromPaper()) {
      this.toogleSignInModal(false);
    } else {
      this.toogleSignInModal(true);
    }
   }

   public toogleSignInModal(isVisible: boolean) {
    if (this.loginElements.length < 1) return;
    if (isVisible) {
      this.loginElements.forEach(el => {
        if (el.classList.contains("login-form-component-hidden")) {
          el.classList.remove("login-form-component-hidden");
          el.classList.add("login-form-component");
        } 
      });
      this.toogleSignInLoader(false);
    }else {
      this.loginElements.forEach(el => {
        if (el.classList.contains("login-form-component")) {
          el.classList.remove("login-form-component");
          el.classList.add("login-form-component-hidden");
        } 
      });
      this.toogleSignInLoader(true);
    }
   }

   
   private isFromPaper(): boolean {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return (this.referrerUrl && this.referrerUrl.includes(ReferrerService.PAPERSUBPATH)) || (urlSearchParams.get("refer_from") == "paper")
  }

   private toogleSignInLoader(isVisible: boolean) {
    const loader = document.querySelector("div.login-loader-wrap");
    const attachTo = document.getElementById("login")?.parentElement;
    if (!attachTo) return;
    if (isVisible ) { 
      if (!loader) attachTo.insertAdjacentElement('afterbegin',this.createLoader());
    } else if (loader) {
      attachTo.removeChild(loader);      
    }
   }

   private createLoader(): HTMLElement {
     const element = document.createElement('div');
      element.classList.add('login-loader-wrap');
      element.innerHTML = '<h1 class="mc-text-center"><i class="fas fa-spinner fa-spin"></i> Sign In ..........</h1>';
      return element; 
   }

}


export default ReferrerService
